<template>
  <div class="flex justify-center items-center h-full hover:bg-primary-light hover:text-primary-focus w-max"
       @mouseover="updateHover(true)"
       @mouseleave="updateHover(false)">
    <div class="flex items-center" :class="iconClass">
      <slot name="icon"/>
    </div>
    <span class="ml-2">{{ formatDate(date) }}</span>
  </div>
</template>

<script>
import datetimeUtils from '@/utils/datetime.utils'

export default {
  name: 'DateFilterValue',

  props: {
    date: {
      type: String,
      required: true
    },
    format: {
      type: String,
      default: 'D MMM, YY'
    }
  },

  data() {
    return {
      isHover: false
    }
  },

  computed: {
    iconClass() {
      return this.isHover ? 'text-primary-focus' : 'text-gray-dark'
    }
  },

  methods: {
    formatDate(dateString) {
      return datetimeUtils.toMoment(dateString).format(this.format)
    },

    updateHover(hover) {
      this.isHover = hover
    }
  }
}
</script>
